import axiosClient from "./axiosClient";

const authApi = {
    post: (data) => {
        const url = '/auth';

        return axiosClient.post(url, data);
    }
}

export default authApi;